import { ROOTS } from "../../data/content";
import { Reveal, Eyebrow } from "./Reveal";

const RecordRow = ({ code, label, last }) => (
  <div
    className={`group flex items-baseline justify-between gap-6 px-6 py-5 transition-colors duration-300 hover:bg-[#faf8f5] ${
      last ? "" : "border-b border-[var(--line)]"
    }`}
  >
    <div className="flex items-baseline gap-5">
      <span className="font-mono text-xs text-[#9c7a33]">{code}</span>
      <span className="font-display text-lg leading-snug text-[#1c2b4a] md:text-xl">
        {label}
      </span>
    </div>
    <span className="hidden h-1.5 w-1.5 shrink-0 border border-[#9c7a33] transition-colors duration-300 group-hover:bg-[#9c7a33] sm:block" />
  </div>
);

export default function Roots() {
  return (
    <section
      id="roots"
      data-testid="roots-section"
      className="border-y border-[var(--line)] bg-[#eae7dd]"
    >
      <div className="mx-auto max-w-[1400px] px-6 py-28 md:px-10 md:py-40">
        <div className="grid gap-14 lg:grid-cols-12 lg:gap-16">
          {/* Archive photograph */}
          <div className="lg:col-span-5">
            <Reveal delay={0.1}>
              <div className="relative">
                <div className="absolute -left-3 -top-3 hidden h-full w-full rounded-sm border border-[#9c7a33]/45 lg:block" />
                <div className="relative overflow-hidden rounded-sm border border-[var(--line)] bg-white p-2 shadow-[0_30px_60px_-30px_rgba(15,23,42,0.35)]">
                  <img
                    src={ROOTS.image}
                    alt="Adonica Shaw, childhood archive photograph"
                    className="h-[480px] w-full rounded-sm object-cover object-[center_28%]"
                  />
                  <span className="absolute left-4 top-4 rounded-sm bg-[#1c2b4a]/85 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-[#faf8f5] backdrop-blur">
                    Archive — Pasadena, CA
                  </span>
                </div>
              </div>
            </Reveal>
            <Reveal delay={0.16}>
              <p className="mt-5 font-mono text-[10px] uppercase tracking-[0.18em] text-[#5c6474]">
                Fig. 01 — Where the work began
              </p>
            </Reveal>
          </div>

          {/* Transcript ledger */}
          <div className="lg:col-span-7">
            <Reveal>
              <Eyebrow testid="roots-eyebrow">{ROOTS.eyebrow}</Eyebrow>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-7 max-w-xl font-display text-4xl font-light leading-[1.02] tracking-tight text-[#1c2b4a] md:text-5xl">
                {ROOTS.heading}
              </h2>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="mt-7 max-w-xl text-base leading-relaxed text-[#5c6474] md:text-lg">
                {ROOTS.body}
              </p>
            </Reveal>

            <Reveal delay={0.2}>
              <div className="mt-12 overflow-hidden rounded-sm border border-[var(--line)] bg-white">
                <div className="flex items-center justify-between border-b border-[var(--line)] bg-[#faf8f5] px-6 py-4">
                  <span className="font-mono text-[11px] uppercase tracking-[0.24em] text-[#9c7a33]">
                    Academic Record
                  </span>
                  <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-[#5c6474]">
                    Education &amp; Training
                  </span>
                </div>
                {ROOTS.education.map((e, i) => (
                  <div key={e} data-testid={`roots-edu-${i}`}>
                    <RecordRow
                      code={`EDU-${String(i + 1).padStart(2, "0")}`}
                      label={e}
                    />
                  </div>
                ))}
                <div className="flex items-center justify-between border-b border-[var(--line)] bg-[#faf8f5] px-6 py-4">
                  <span className="font-mono text-[11px] uppercase tracking-[0.24em] text-[#9c7a33]">
                    Certifications
                  </span>
                  <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-[#5c6474]">
                    Practice
                  </span>
                </div>
                {ROOTS.certifications.map((c, i) => (
                  <div key={c} data-testid={`roots-cert-${i}`}>
                    <RecordRow
                      code={`CRT-${String(i + 1).padStart(2, "0")}`}
                      label={c}
                      last={i === ROOTS.certifications.length - 1}
                    />
                  </div>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
